export const currency = "EUR"